import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordNotificationComponent } from './forgot-password-notification/forgot-password-notification.component';
import { RouterModule } from '@angular/router';
import { notificationRoutes } from './notification.route';
import { PhoneSendNotificationComponent } from './phone-send-notification/phone-send-notification.component';
import { WhatIsPaycellComponent } from './what-is-paycell/what-is-paycell.component';
import { NzModalModule } from 'ng-zorro-antd';
import { AccountSuspensionComponent } from './account-suspension/account-suspension.component';
import { SharedCommonModule } from '../shared-common.module';
import { CardEulaComponent } from './card-eula/card-eula.component';
import { AccountEulaComponent } from './account-eula/account-eula.component';
import { CvvInfoComponent } from './cvv-info/cvv-info.component';
import {AccountKvkkComponent} from "./account-kvkk/account-kvkk.component";
import {AccountEtkComponent} from "./account-etk/account-etk.component";

const DECLARATIONS_AND_EXPORT = [
  ForgotPasswordNotificationComponent,
  PhoneSendNotificationComponent,
  WhatIsPaycellComponent,
  AccountSuspensionComponent,
  CardEulaComponent,
  AccountEulaComponent,
  AccountKvkkComponent,
  AccountEtkComponent,
  CvvInfoComponent
];

@NgModule({
  declarations: [DECLARATIONS_AND_EXPORT],
  imports: [
    CommonModule,
    RouterModule.forChild(notificationRoutes),
    NzModalModule,
    SharedCommonModule
  ],
  exports: [DECLARATIONS_AND_EXPORT]
})
export class NotificationModule {
}
